import { getAuth } from 'shared/services/firebase';
import { ref } from 'vue';

export default function useCurrentUser() {
  const auth = getAuth();
  const currentUser = ref(null);
  const loading = ref(true);
  auth.onAuthStateChanged((u) => {
    loading.value = false;
    if (u === null) {
      currentUser.value = null;
      return;
    }
    currentUser.value = u;
  });

  return { currentUser, loading };
}
